<div *ngIf="config?.one_time_donation" class="payment-upi">
  <!-- Qr Code and UPI Icons -->
  <app-qrcode-box *ngIf="!isMobile" [config]="config" [code]="paymentV2?.upiQrCode"></app-qrcode-box>

  <!-- add upi id - Desktop -->
  <div *ngIf="!isMobile" class="upi-id-warpper">
    <div class="head">
      <div class="title">Add New UPI ID</div>
      <div class="text">You need a registered UPI ID</div>
    </div>
    <div class="upi-input">
      <app-payment-sip-upi [config]="config" [showTime]="false" (dataEmit)="dataEmit.emit($event)"></app-payment-sip-upi>
    </div>
  </div>

  <div *ngIf="isMobile" class="upi-id-warpper">
    <app-payment-method-list *ngIf="config?.paymentOptions?.options?.TOPUPI && util.getMobileOperatingSystem() !== 'iOS'" [config]="config"
                            [listConfig]="{
                              wrapClass: 'UPI',
                              list: config?.paymentOptions?.options?.TOPUPI,
                              selected: selectedUPI || this.config?.upiMode?.value,
                              type: 'radio',
                              showIcon: true,
                              showSubmitBtn: true,
                              onChangeEvent: true
                            }"
                            (submitPayment)="dataEmit.emit({mode: 'UPI', mode_value: $event.key})" (onChange)="selectedUPI=$event">
    </app-payment-method-list>

    <mat-radio-group  class="top-brands" [(ngModel)]="selectedUPI" labelPosition="before" color="primary" name="selectedUPI">
      <mat-radio-button class="brand other" [ngClass]="{'selected': selectedUPI==='other'}" value="other">
        <div class="head">
          <div class="add-icon"><i class="material-icons">add</i></div>
          <div>
            <div class="title">Add New UPI ID</div>
            <div class="text">You need to have a registered UPI ID</div>
            <div *ngIf="selectedUPI!=='other'" class="upi-icons">
              <span *ngFor="let item of (config?.paymentOptions?.options?.TOPUPI | keyvalue)" class="payment-icons" [ngClass]="item?.key?.toUpperCase()"></span>
            </div>
          </div>
        </div>
      </mat-radio-button>
    </mat-radio-group>

    <div *ngIf="selectedUPI==='other'" class="upi-input">
      <app-payment-sip-upi [showTime]="false" [config]="config" (dataEmit)="dataEmit.emit($event)"></app-payment-sip-upi>
      <app-payment-sip-button [config]="config" (btnClick)="paymentV2.pledgeBtn.next('upi')"></app-payment-sip-button>
    </div>

  </div>
</div>